import { NextBestActionEnum } from '../../../graphql.generated';

type Action = {
    action: NextBestActionEnum;
    extraDetails?: unknown;
};

export const getNextBestActionFromBackend = (
    actions: Action[]
): ('preferences' | 'your-situation' | 'confirmation')[] => {
    const nextBestActionMap: {
        [key in NextBestActionEnum]:
            | 'preferences'
            | 'your-situation'
            | 'confirmation';
    } = {
        [NextBestActionEnum.EmailMarketingConsent]: 'preferences',
        [NextBestActionEnum.UpdateYourSituation]: 'your-situation',
        [NextBestActionEnum.VendorLeadNudge]: 'confirmation'
    };

    return actions
        .filter((item) => nextBestActionMap[item.action])
        .map((item) => nextBestActionMap[item.action]);
};

type User = {
    nextBestAction?: {
        actions?: Action[];
    } | null;
};

export const getNextBestAction = (
    user: User,
    isRegistrationForm?: boolean
): ('preferences' | 'your-situation' | 'confirmation')[] => {
    if (
        !user.nextBestAction?.actions ||
        user.nextBestAction?.actions.length === 0
    ) {
        return [];
    }

    const actions = getNextBestActionFromBackend(user.nextBestAction.actions);

    // if the user has gone through the form
    // they have already been asked their preferences
    if (isRegistrationForm) {
        return actions.filter((action) => action !== 'preferences');
    }

    return actions;
};
